import { action } from '@reatom/framework'

import { User } from '@root/entities/auth/model'

import { createRpc, createSendAction } from './reatom-create-rpc'
import { workerAtom } from './reatom-worker'

import type { ClientToWorkerMessage } from '../model/client-to-worker-message'

export { initializeWorkerAction, workerAtom } from './reatom-worker'
export const putUserToWorkerAction = action((ctx, user: User.User) => {
  const worker = ctx.get(workerAtom)
  if (!worker) {
    return
  }
  const userEncoded = User.encode(user)
  if (!userEncoded) {
    return
  }
  const message: ClientToWorkerMessage = {
    type: 'store:user:put',
    user: userEncoded,
  }
  worker.port.postMessage(message)
}, 'putUserToWorkerAction')

export const putSessionToWorkerAction = createSendAction({
  requestType: 'store:session:put',
})
export const getSessionFromWorkerAction = createRpc({
  requestType: 'store:session:get',
  responseType: 'store:session:push',
})

export const getUserFromWorkerAction = createRpc({
  requestType: 'store:user:get',
  responseType: 'store:user:push',
})
